import { LitElement, html, nothing } from "lit";
import { property } from "lit/decorators.js";
import { customElement } from "lit/decorators/custom-element.js";
import { tileStyles } from "./tile.styles";
import "@/components/headline-link/headline-link";
import "./tile.scss";
import {classMap,ClassInfo} from "lit/directives/class-map.js";

@customElement("sbk-tile")
export class SbkTile extends LitElement {
    static shadowRootOptions = {
        ...LitElement.shadowRootOptions,
        delegatesFocus: true,
    };

    @property({ type: String })
    headline = "";

    @property({ type: String })
    variant: "default" | "summary" = "default";

    @property()
    icon = "";

    @property()
    amount = "";

    @property()
    href = "";

    constructor() {
        super();
    }

    static get styles() {
        return tileStyles;
    }

    render() {
        if (!this.href) {
            return html`
                <div class=${classMap(this.getClassMap())}>
                    <div class="tile__content">
                        ${this._renderHeadlineLinkAndIcon()}
                        ${this._renderAmountAndChevron()}
                    </div>
                </div>
            `;
        }
        return html`
            <a class=${classMap(this.getClassMap())} href=${this.href}>
                <div class="tile__content">
                    ${this._renderHeadlineLinkAndIcon()}
                    ${this._renderAmountAndChevron()}
                </div>
            </a>
        `;
    }

    _renderHeadlineLinkAndIcon() {
        if (this.variant === 'summary') {
            return html`
            <div class="tile_headline-icon">
                ${this._renderHeadline()}
            </div>
        `;
        }
        return html`
            <div class="tile_headline-icon">
                ${this._renderIcon()}
                ${this._renderHeadline()}
            </div>
        `;
    }

    _renderIcon() {
        return this.icon
            ? html`<sbk-icon size="40" symbol=${this.icon}></sbk-icon>`
            : nothing;
    }

    _renderHeadline() {
        if (this.headline) {
            return html`
                <p class="headline">${this.headline}</p>
            `;
        }
        return nothing;
    }

    _renderAmountAndChevron() {
        if (this.variant === 'summary') {
            return html`
            <div class="tile_amount-icon">
                ${this._renderAmount()}
            </div>
        `;
        }
        return html`
            <div class="tile_amount-icon">
                ${this._renderAmount()}
                <sbk-icon size="24" symbol="chevron-right"></sbk-icon>
            </div>
        `;
    }

    _renderAmount() {
        return html`
            ${this.amount
                ? html`<div class="amount"><span class="price">${this.amount}</span></div>`
                : nothing}
        `;
    }

    getClassMap(): ClassInfo {
        return {
            'tile': true,
            [`tile--variant-${this.variant}`]: !!this.variant,
            'tile--clickable': !!this.href,
        };
    }
}

